module.exports = __webpack_public_path__ + "img/avatar3.9e6af78c.png";